import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ModalButtons } from '@fcom/ui-components';

@Component({
  selector: 'fin-am-destination-continue-modal',
  templateUrl: './am-destination-continue-modal.component.html',
})
export class AmDestinationContinueModalComponent {
  public readonly ModalButtons: typeof ModalButtons = ModalButtons;

  @Input()
  open = false;

  @Input()
  bookUrl: string;

  @Output()
  closeModal: EventEmitter<void> = new EventEmitter();

  navigateToAmBooking(): void {
    // open a new am tab
    window.open(`${this.bookUrl}&utm_content=destination_list`, '_blank');
  }
}
